import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';

import { ConfigOrcamento } from '../../../../../shared/services/models/vendas/config-orcamento.model';

/**
 * Secao Introducao [ORC] — o texto impresso antes dos itens da proposta.
 *
 * E ngx-editor, e nao um textarea, porque a configuracao "Introducao padrao dos orcamentos" e
 * editada com ngx-editor e grava HTML. Um textarea aqui mostraria as tags ao vendedor.
 *
 * A configuracao manda em duas coisas: o texto que ja vem preenchido no documento novo, e se o
 * vendedor pode altera-lo (`isIntroducaoEditavel`). Quando nao pode, o campo fica desabilitado —
 * e o backend grava o valor da configuracao de qualquer jeito, entao a tela so esta mostrando a
 * verdade, nao protegendo nada sozinha.
 */
@Component({
    selector: 'app-vd-introducao',
    standalone: true,
    imports: [ReactiveFormsModule, MatIconModule, MatTooltipModule, NgxEditorModule],
    templateUrl: './vd-introducao.component.html',
    styleUrl: './vd-introducao.component.css',
})
export class VdIntroducaoComponent implements OnInit, OnChanges, OnDestroy {
    @Input({ required: true }) public form!: FormGroup;
    @Input() public configOrcamento: ConfigOrcamento | null = null;

    /** Somente-leitura do documento inteiro (etapa de encerramento, story 1.4). */
    @Input() public isSomenteLeitura: boolean = false;

    public editor!: Editor;

    // Mesma barra da tela de configuracao, para o que o vendedor edita bater com o que foi
    // configurado. Sem link, imagem, tabela, codigo nem h4+.
    public readonly toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3'] }],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
    ];

    public ngOnInit(): void {
        this.editor = new Editor();
        this.aplicarBloqueio();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['configOrcamento'] || changes['isSomenteLeitura']) this.aplicarBloqueio();
    }

    /**
     * Travado = controle DESABILITADO, não só CSS: `pointer-events: none` escondia o editor do
     * mouse, mas ele continuava focável por Tab e editável. Com o controle desabilitado o
     * ngx-editor entra em leitura de verdade; o visual do `.editor-bloqueado` continua só para o
     * vendedor ler o texto que será impresso. Em somente-leitura o shell já desabilitou o form
     * inteiro, por isso o `enable` só volta quando nada trava.
     */
    private aplicarBloqueio(): void {
        const controle = this.form?.get('introducaoProposta');

        if (!controle) return;

        if (this.isBloqueado) controle.disable({ emitEvent: false });
        else controle.enable({ emitEvent: false });
    }

    public ngOnDestroy(): void {
        this.editor?.destroy();
    }

    /** Travado pela configuracao, ou pelo documento inteiro estar em somente-leitura. */
    public get isBloqueado(): boolean {
        return this.isSomenteLeitura || this.configOrcamento?.isIntroducaoEditavel === false;
    }
}
